import { Chip, InputAdornment, Paper, TextField } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useRef, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles()((theme) => ({
    wrapper: {
        padding: "2px 16px",
        backgroundColor: theme.palette.mode === "light" ? "#eee" : "#20252c",
    },
    icon: {
        fontSize: 18,
        color: theme.palette.text.secondary,
    },
    inputRoot: {
        display: "flex",
        alignItems: "center",
        minHeight: 34,
    },
}));

function TagsContainerComponent({ ticket }) {
    const { classes } = useStyles();
    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        loadTags();
    }, []);

    useEffect(() => {
        setSelecteds(Array.isArray(ticket.tags) ? ticket.tags : []);
    }, [ticket]);

    const loadTags = async () => {
        try {
            const { data } = await api.get(`/tags/list`);
            setTags(data);
        } catch (err) {
            toastError(err);
        }
    };

    const syncTags = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags/sync`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    };

    const onChange = async (value) => {
        setSelecteds(value);
        await syncTags({ ticketId: ticket.id, tags: value });
    };

    return (
        <Paper elevation={0} square className={classes.wrapper}>
            <Autocomplete
                multiple
                size="small"
                disableCloseOnSelect
                options={tags}
                value={selecteds}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, v) => onChange(v)}
                getOptionLabel={(option) => option.name}
                renderValue={(value, getItemProps) =>
                    value.map((option, index) => (
                        <Chip
                            variant="outlined"
                            style={{
                                backgroundColor: option.color || "#eee",
                                textShadow: "1px 1px 1px #000",
                                color: "white",
                            }}
                            label={option.name}
                            {...getItemProps({ index })}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        placeholder="Agregar tags"
                        classes={{ root: classes.inputRoot }}
                        slotProps={{
                            ...params.slotProps,
                            input: {
                                ...params.slotProps?.input,
                                disableUnderline: true,
                                startAdornment: (
                                    <>
                                        <InputAdornment position="start">
                                            <LabelOutlinedIcon className={classes.icon} />
                                        </InputAdornment>
                                        {params.slotProps?.input?.startAdornment}
                                    </>
                                ),
                            },
                        }}
                    />
                )}
            />
        </Paper>
    );
}

export const TagsContainer = React.memo(
    TagsContainerComponent,
    (prev, next) =>
        prev.ticket?.id === next.ticket?.id &&
        JSON.stringify(prev.ticket?.tags || []) === JSON.stringify(next.ticket?.tags || [])
);
